import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_SHIPPING_LISTING,
    ADD_SHIPPING,
    UPDATE_SHIPPING,
    DELETE_SHIPPING,
    EXPORT_SHIPPING,
    GET_SHIPPING_DETAILS,
} from "./actionTypes.js";

import {
    getShippingListingSuccess,
    getShippingListingFail,
    createShippingSuccess,
    createShippingFail,
    updateShippingSuccess,
    updateShippingFail,
    deleteShippingSuccess,
    deleteShippingFail,
    exportShippingSuccess,
    exportShippingFail,
    getShippingDetailsSuccess,
    getShippingDetailsFail,
} from "./actions.js";

import {
    shippingListingApi,
    shippingDetailsApi,
    addShippingApi,
    updateShippingApi,
    deleteShippingApi,
    exportShippingApi,
} from "./shippingApi.js";

function* fetchShippingListing({ payload }) {
    try {
        const response = yield call(shippingListingApi, payload);
        yield put(getShippingListingSuccess(response));
    } catch (error) {
        yield put(getShippingListingFail(error));
    }
}

function* fetchShippingDetail({ payload }) {
    try {
        const response = yield call(shippingDetailsApi, payload);
        yield put(getShippingDetailsSuccess(response));
    } catch (error) {
        yield put(getShippingDetailsFail(error));
    }
}

function* createShipping({ payload }) {
    try {
        const response = yield call(addShippingApi, payload);
        yield put(createShippingSuccess(response));
    } catch (error) {
        yield put(createShippingFail(error));
    }
}

function* updateShipping({ payload }) {
    try {
        const response = yield call(updateShippingApi, payload);
        yield put(updateShippingSuccess(response));
    } catch (error) {
        yield put(updateShippingFail(error));
    }
}

function* deleteShipping({ payload }) {
    try {
        const response = yield call(deleteShippingApi, payload);
        yield put(deleteShippingSuccess(response));
    } catch (error) {
        yield put(deleteShippingFail(error));
    }
}

function* exportShipping({ payload }) {
    try {
        const response = yield call(exportShippingApi, payload);
        yield put(exportShippingSuccess(response));
    } catch (error) {
        yield put(exportShippingFail(error));
    }
}

function* ShippingSaga() {
    yield takeEvery(GET_SHIPPING_LISTING, fetchShippingListing);
    yield takeEvery(GET_SHIPPING_DETAILS, fetchShippingDetail);
    yield takeEvery(ADD_SHIPPING, createShipping);
    yield takeEvery(UPDATE_SHIPPING, updateShipping);
    yield takeEvery(DELETE_SHIPPING, deleteShipping);
    yield takeEvery(EXPORT_SHIPPING, exportShipping);

}

export default ShippingSaga
